import React, {Component} from 'react';

 
import axios from 'axios'; 
import { BrowserRouter, Routes, Link, Route } from 'react-router-dom'; 
import {api_base_url, base_url} from '../common/Constants'; 
import { SharedContext } from '../pages/createContext';

class Header extends Component {
    static contextType = SharedContext;
    constructor(){
        super();
        
        this.state = {
            scrolled: false
          };
        }
      
        componentDidMount() {
          window.addEventListener('scroll', this.handleScroll);
        }
      
        componentWillUnmount() {
          window.removeEventListener('scroll', this.handleScroll);
        }
      
        handleScroll = () => {
          const isScrolled = window.scrollY > 50;
          if (isScrolled !== this.state.scrolled) {
            this.setState({ scrolled: isScrolled });
          }
        }; 
    render()
    {
        
        const { scrolled } = this.state;

        const headerStyle = {
          position: 'sticky',
          top: 0,
          zIndex: 999, 
          transition: 'all 0.3s ease',
          padding: scrolled ? '10px 20px' : '20px 20px',
          height: scrolled ? '50px' : '80px', 
        };
     
    
  return (
    <div>
        <div className="top-bar-area inc-border bg-dark">
        <div className="container">
            <div className="row">
                <div className="col-md-9 address-info text-left">
                    <div className="info box">
                        <ul>
                            
                            
                            <li>
                                <div className="icon">
                                    
                                </div>
                                <div className="info">
                                   
                                </div>
                            </li>
							<li>
                                <div className="icon">
                                    
                                </div>
                                <div className="info">
                                    
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-3 social text-right">
                    <ul>
                        
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <header id="home">
    <div class={scrolled ? "wrap-sticky" : ""} style={{ height: scrolled ? "82px":"" }}>
        <nav  className={scrolled ? " navbar navbar-default active-border attr-border navbar-sticky bootsnav  sticked" : "navbar navbar-default active-border attr-border navbar-sticky bootsnav  "}>

           
            <div className="container">
                <div className="row">
                    <div className="top-search">
                        <div className="input-group">
                            <form action="#">
                                <input type="text" name="text" className="form-control" placeholder="Search" />
                                <button type="submit">
                                    <i className="fas fa-search"></i>
                                </button>  
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container"> 
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                        <i className="fa fa-bars"></i>
                    </button>
                    <Link className="navbar-brand" to="/">
                        <img src={base_url+"assets/img/logo.png"} className="logo" alt="Logo" />
                    </Link>
                </div>
                 <div className="collapse navbar-collapse" id="navbar-menu">
                    <ul className="nav navbar-nav navbar-right" data-in="#" data-out="#">
                        <li className="dropdown active">
                            <Link to="/">Home</Link>
                            
                        </li>
                        <li className="dropdown">
                            <Link to="#" className="dropdown-toggle smooth-menu" data-toggle="dropdown" >About Us</Link>
                            <ul className="dropdown-menu">
                                
                                <li><Link to={base_url+`about-us`}>About Cool Pro</Link></li>
                                <li><Link to={base_url+`quality-policy`}>Quality Policy</Link></li>
								<li><Link to={base_url+`certificates`}>Certificates</Link></li>
                                <li><Link to={base_url+`chairmans-message`}>Chairman's Message</Link></li>
                                
                            </ul>
                        </li>
                        <li className="dropdown">
                            <Link to="#" className="dropdown-toggle smooth-menu" data-toggle="dropdown" >Our Products</Link>
                            <ul className="dropdown-menu">
                            {JSON.parse(localStorage.getItem("categories")).map((item, index) => (
                                <li><Link to={base_url+`products/${item.slug}`}>{item.title}</Link></li>
                            ))} 
                                
                            </ul>
                        </li>
                        <li className="dropdown">
                            <Link to={base_url+`machines`}>List of Machines</Link>
                            
                        </li>
                       {/* <li className="dropdown">
                            <Link to="#" className="dropdown-toggle smooth-menu" data-toggle="dropdown" >Project List</Link>
                            <ul className="dropdown-menu">
                            {JSON.parse(localStorage.getItem("project_types")).map((item, index) => (
                                <li><Link to={base_url+`project-list/${item.slug}`}>{item.title}</Link></li>
                            ))} 
                                
                            </ul>
                        </li> */}
                        <li className="dropdown">
                            <Link to={base_url+`projects`}>Projects</Link>
                            
                        </li> 
                        <li className="dropdown">
                            <Link to={base_url+`clients`}>Clients</Link>
                            
                        </li>
                        <li className="dropdown">
                            <Link to={base_url+`blog`}>Blog</Link>
                            
                        </li>

                        <li>
                            <Link to={base_url+`contact`}>
                            contact</Link>
                        </li>
                    </ul>
                </div> 
</div>
        </nav>
      </div>
    </header>
    </div>
    
  );
}
};

export default Header;